import { useEffect } from "react";
import { useHotkeysContext } from "react-hotkeys-hook";
import { HOTKEYS_SCOPES } from "./useKeyboardCommand";

/**
 * Hook to switch between keyboard scopes on mount/unmount
 * @param enabledScope - The scope to enable when component mounts
 * @param disabledScope - The scope to disable when component mounts
 */
export const useScopeSwitch = (
    enabledScope: string,
    disabledScope: string = HOTKEYS_SCOPES.MAIN,
) => {
    const { enableScope, disableScope } = useHotkeysContext();

    useEffect(() => {
        enableScope(enabledScope);
        disableScope(disabledScope);
        return () => {
            disableScope(enabledScope);
            enableScope(disabledScope);
        };
    }, [enableScope, disableScope, enabledScope, disabledScope]);
};
